// src/components/DynamicIcon.tsx
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { findIconDefinition } from '@fortawesome/fontawesome-svg-core';
import { parseIconClass } from '../utils/fontawesome';

/**
 * Componente che renderizza un'icona Font Awesome da una stringa di classe
 * 
 * @example
 * // Renderizza un'icona casa
 * <DynamicIcon iconClass="fas fa-house" size="2x" />
 */
const DynamicIcon = ({ iconClass, color, ...props }) => {
    if (!iconClass) return null;

    const iconLookup = parseIconClass(iconClass);

    if (!iconLookup) return null;

    const iconDefinition = findIconDefinition(iconLookup);

    if (!iconDefinition) {
        console.warn(`Icon not found: ${iconClass}`);
        return null;
    }
    return <FontAwesomeIcon
                className={`cursor-pointer ${color}`}
                icon={iconDefinition}
                {...props}
            />;
};

export default DynamicIcon;